import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/local/target.css?{\"path\":\"src/app/styles/fonts.ts\",\"import\":\"\",\"arguments\":[{\"src\":\"./fonts/EyesomeScript.otf\"}],\"variableName\":\"eyesomeScript\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/local/target.css?{\"path\":\"src/app/styles/fonts.ts\",\"import\":\"\",\"arguments\":[{\"src\":\"./fonts/EyesomeRegular.otf\"}],\"variableName\":\"eyesomeRegular\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/local/target.css?{\"path\":\"src/app/styles/fonts.ts\",\"import\":\"\",\"arguments\":[{\"src\":\"./fonts/EyesomeItalic.otf\"}],\"variableName\":\"eyesomeItalic\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/local/target.css?{\"path\":\"src/app/styles/fonts.ts\",\"import\":\"\",\"arguments\":[{\"src\":\"./fonts/Lora-Variable.ttf\"}],\"variableName\":\"lora\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/local/target.css?{\"path\":\"src/app/styles/fonts.ts\",\"import\":\"\",\"arguments\":[{\"src\":\"./fonts/Lora-VariableItalic.ttf\"}],\"variableName\":\"loraItalic\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/beckenhamlivingroom/1.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/beckenhamlivingroom/3.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/greenBadgeLogo.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/hubbadge24.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/hubbadge25.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/insurance.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/kentkitchen/1.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/map.jpg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/Components/Header/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/globals.css");
